import React from "react";
const InfoSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className="svg__info"
    >
      <circle cy="24" cx="24" r="24" />
      <g fill="#fff">
        <circle cx="24" cy="11.6" r="4.7" />
        <path d="m17.4 18.8v2.15h1.13c2.26 0 2.26 1.38 2.26 1.38v15.1s0 1.38-2.26 1.38h-1.13v2.08h14.2v-2.08h-1.13c-2.26 0-2.26-1.38-2.26-1.38v-18.6" />
      </g>
    </svg>
  );
};

export default InfoSVG;



// WEBPACK FOOTER //
// ./src/components/icons/infoSVG.js